module.exports = __webpack_public_path__ + "static/img/31.24ca555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/31.png
// module id = YsWd
// module chunks = 1